import React, { forwardRef, useContext } from 'react';

const withContexts = (contexts, options = {}) => {
  return (Component) => {
    const render = (props, a, b, c) => {
      const contextProps = {};
      Object.entries(contexts).forEach(([contextName, context]) => {
        contextProps[contextName] = useContext(context);
      });

      const childProps = {
        ...contextProps,
        ...props,
      };

      return <Component {...childProps} />;
    };

    if (options.forwardRef) {
      return forwardRef((props, ref) =>
        render({
          ...props,
          ref,
        })
      );
    }

    return render;
  };
};

export default withContexts;
